import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { WarehouseTransferReasonType } from './warehouse-transfer-reason-type';

export class WarehouseTransferReason extends BaseEntity{
    
    warehouseTransferReasonCode : string;
    name : string;
    warehouseTransferReasonType    : WarehouseTransferReasonType;
    rank : number;
}